import React from 'react';
import OptimizationDashboard from '../components/OptimizationDashboard';

const Approvisionnement: React.FC = () => {
  return <OptimizationDashboard />;
};

export default Approvisionnement;
